import { Component } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { UnpaidService, UnpaidSummary } from '../../core/unpaid.service';

@Component({
  selector: 'app-unpaid-summary',
  templateUrl: './unpaid-summary.component.html',
  styleUrls: ['./unpaid-summary.component.scss'],
})
export class UnpaidSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: UnpaidSummary;

  constructor(private error_service: ErrorService, private unpaid_service: UnpaidService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.unpaid_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
